// Reuse the old ERP frontend's existing authenticated request utility.
// Adjust this import if the project stores its request utility elsewhere.
import { ajaxPost, ajaxGet, Baseurl } from './api/api.js'

const base = 'amazonPremiumListing'


export const premiumShops = () => ajaxPost(`${Baseurl}${base}/shops`, {})
export const premiumList = params => ajaxPost(`${Baseurl}${base}/list`, params)
export const premiumDetail = id => ajaxPost(`${Baseurl}${base}/detail`, { id })
export const premiumSave = data => ajaxPost(`${Baseurl}${base}/save`, data)
export const premiumSubmit = id => ajaxPost(`${Baseurl}${base}/submit`, { id })
export const premiumAttachKey = (id, contentReferenceKey) => ajaxPost(`${Baseurl}${base}/attachKey`, { id, contentReferenceKey })
export const premiumRegisterMedia = data => ajaxPost(`${Baseurl}${base}/media/register`, data)
export const premiumUploadMedia = (shopId, marketplaceId, file) => {
  const form = new FormData()
  form.append('shopId', shopId)
  form.append('marketplaceId', marketplaceId)
  form.append('file', file)
  return ajaxPost(`${Baseurl}${base}/media/upload`, form, { timeout: 180000 })
}
